import { EAddressType } from '@/__generated__/useAccountAllocationsDataQuery.graphql'
import { DEFAULT_CHAIN_ID } from '@/lib/chains'
import { commitLocalUpdate, Environment } from 'relay-runtime'
import { Address } from 'viem'

const listeners = new Set<(walletAddress: Address, walletType: EAddressType) => void>()

export function subscribeToClaimUpdates(
  callback: (walletAddress: Address, walletType: EAddressType) => void
): () => void {
  listeners.add(callback)
  return () => {
    listeners.delete(callback)
  }
}

export function updateWalletClaimStatus(
  environment: Environment,
  walletAddress: Address,
  walletType: EAddressType
) {
  commitLocalUpdate(environment, (store) => {
    const records = store.getRoot().getLinkedRecords('zoraTokenAllocation', {
      identifierWalletAddresses: [walletAddress],
      chainId: DEFAULT_CHAIN_ID,
    })

    if (!records || records.length === 0) return

    const totalTokensEarned = records[0]?.getLinkedRecord('totalTokensEarned')
    if (!totalTokensEarned) return

    const walletAllocations = totalTokensEarned.getLinkedRecords('walletAllocation')
    if (!walletAllocations) return

    walletAllocations.forEach((allocation) => {
      const address = allocation.getValue('walletAddress')
      if (address === walletAddress) {
        if (!walletType || allocation.getValue('walletType') === walletType) {
          allocation.setValue('CLAIMED', 'claimStatus')
        }
      }
    })

    totalTokensEarned.setLinkedRecords(walletAllocations, 'walletAllocation')

    // Set a timestamp on the root record
    store.getRoot().setValue(Date.now().toString(), '__updateTimestamp')
  })

  // Notify listeners after the store update
  if (listeners.size > 0) {
    setTimeout(() => {
      listeners.forEach((listener) => {
        try {
          listener(walletAddress, walletType)
        } catch (e) {
          console.error('Error in claim status update listener', e)
        }
      })
    }, 0)
  }
}
